export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14269.ebc3cfb9.jpg";